import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { HiddenSpan } from "../Styled/Accessibility"
import { Brand } from "../Icon/Brand"
import { withHeaderBrand } from "./withHeaderBrand"

const Wrapper = styled.div`
  ${tw`absolute inset-0 md:relative flex w-full md:w-2/9 justify-center items-center p-1-6 transition-all duration-slow z-20 `}
  ${({ activeHover }) => (activeHover ? tw`md:z-50` : tw`md:z-40`)}
`
// ${({ activemenu, activecart, active }) =>
//active ? tw`opacity-0 invisible` : activemenu || activecart ? tw`opacity-0 invisible md:opacity-100 md:visible` : tw`opacity-100 visible`}
const StyledBrandLink = tw(Link)`w-1/3 md:w-full`
const StyledLogo = tw.div`w-full m-auto`
//activemenu={activeMenu ? `true` : undefined} activecart={activeCart ? `true` : undefined} active={active ? `true` : undefined}
const HeaderBrand = withHeaderBrand(({ title, url, activeHover }) => {
  return (
    <Wrapper activeHover={activeHover}>
      <StyledBrandLink to={url}>
        <StyledLogo>
          <Brand theme={`dark`} />
        </StyledLogo>
        <HiddenSpan>{title}</HiddenSpan>
      </StyledBrandLink>
    </Wrapper>
  )
})

export default HeaderBrand
